import React from 'react';
import ModalHeader from 'react-bootstrap/ModalHeader';
import { Button, ModalBody, ModalFooter, Table } from 'react-bootstrap';
import ProductImage from '../ProductImage';

import { faTimesCircle } from '@fortawesome/free-regular-svg-icons';
import axios from 'axios';
import { useAlert } from 'react-alert';
import { IconWrapper } from '../IconWrapper';

export default function DeleteOrderLine({
    setShowDeleteConfirmation,
    cas,
    orderId,
    orderLineId,
    refreshOrderInfo,
    image,
    description,
    code
}) {
    let alert = useAlert();

    let deleteLine = () => {
        setShowDeleteConfirmation(false);
        axios
            .delete(
                window.CONFIG['ws.activoc-web-order-api.order.lines.delete']
                    .replace('{id}', orderId)
                    .replace('{lineId}', orderLineId),
                {
                    headers: {
                        Authorization: cas,
                        'Content-Type': 'application/json'
                    }
                }
            )
            .then(() => {
                alert.success(
                    <>
                        REMOVED
                        <strong>
                            {' '}
                            {code} {description}{' '}
                        </strong>
                        from your order
                    </>
                );
                refreshOrderInfo();
            })
            .catch(() => alert.error('ERROR: Unable to remove product from order'));
    };

    return (
        <>
            <ModalHeader closeButton>
                <h2>Remove Product</h2>
            </ModalHeader>
            <ModalBody>
                Are you sure you want to remove this product from the order?
                <Table className={'delete-table'}>
                    <tbody>
                        <tr>
                            <td>
                                <ProductImage src={image} alt={'Brandbank image for ' + description} />
                            </td>
                            <td>{code}</td>
                            <td>{description.toUpperCase()}</td>
                        </tr>
                    </tbody>
                </Table>
            </ModalBody>
            <ModalFooter>
                <Button variant={'secondary'} onClick={() => setShowDeleteConfirmation(false)}>
                    <IconWrapper icon={faTimesCircle} />
                    Cancel
                </Button>
                <Button className={'logout'} onClick={deleteLine}>
                    Remove
                </Button>
            </ModalFooter>
        </>
    );
}
